// extracted by mini-css-extract-plugin
module.exports = {"calendarWrapper":"MenusWidget_calendarWrapper__31dcd","calendar":"MenusWidget_calendar__1G0El"};